import React from 'react';
import {Upload, Icon, Button, Select, Row, Col, DatePicker} from 'antd';
import * as moment from 'moment';

const Option = Select.Option;
import download from '../../../util/fileDownload';
import Cabinet from './FileCabinet';

class Document extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            fileList: [],
            docType: null,
            expiryDate: moment()
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.documents.length) {

            const fileList = nextProps.documents.map(({id: uid, file: {original_file_name: name, status = 'done'}, doc_type, expiry}) => {
                const getColor = () => {
                    let color = '#52c41a';
                    if (!expiry) return color;

                    const diff = moment(expiry.date, 'YYYY-MM-DD').diff(moment(), 'days');
                    if (diff < 0) {
                        color = '#f5222d';
                    } else if (diff < 60) {
                        color = '#faad14'
                    }
                    return color;
                };
                name = `${expiry ? 'Exp. Date: ' + moment(expiry.date, 'YYYY-MM-DD').format('DD/MM/YYYY') + ' - ' : ''}${name}`;

                const file = {
                    docType: doc_type,
                    expiry,
                    uid,
                    name,
                    status,
                    url: nextProps.generateUrl(uid),
                    linkProps: {style: {color: getColor()}}
                };
                if (!expiry) delete file.linkProps;
                return file;
            });
            return {fileList, loading: false, setting: null};
        }
        return {fileList: [], loading: false, setting: null};
    }
    handleChange(info) {
        this.setState({
            loading: info.file.status === 'uploading',
            fileList: [...info.fileList]
        });
    }
    onSelect(val) {
        this.setState({docType: val});
    }
    onChange(val) {
        this.setState({expiryDate: val});
    }
    render() {
        const {onUpload, onDelete, uploadError, disabled} = this.props;
        const {fileList, loading, docType, expiryDate} = this.state;
        const docTypes = ['EPC', 'Safety Certificate', 'Fire Risk Assessment', 'Asbestos Risk Assessment', 'Legionella Risk Assessment'];

        const onPreview = (file) => {
            const {url, name} = file;
            return download(url, name);
        };
        const onClick = file => e => {
            e.preventDefault();
            e.stopPropagation();
            return onPreview(file);
        }
        const handleUpload = ({
            data,
            file,
            filename,
            onError,
            onProgress,
            onSuccess
        }) => {
            const formData = new FormData();
            Object.keys(data).forEach(key => {
                formData.append(key, data[key]);
            });
            formData.append(filename, file);

            return onUpload(formData).then(() => {
                if (!uploadError) {
                    file.status = 'done';
                    return onSuccess(file);
                }

                const {res: {errors, message}} = uploadError;
                file.status = 'error';
                file.response = message;
                return onError(file);
            });
        };
        const handleDelete = (doc) => {
            return onDelete(doc.uid);
        };

        return (
            <div id="property-document">
                <Row gutter={16}>
                    <Col span={16}>
                        <Select onChange={this.onSelect.bind(this)} style={{width: '100%'}} disabled={disabled}>
                            {docTypes.map((type, i) => <Option value={type} key={i}>{type}</Option>)}
                        </Select>
                    </Col>
                    <Col span={8}>
                        <DatePicker format='DD/MM/YYYY' onChange={this.onChange.bind(this)} value={expiryDate} placeholder="Expiry Date"/>
                    </Col>
                </Row>
                <Row>
                    <Upload
                        name="document"
                        data={{doc_type: docType, expiry: expiryDate && expiryDate.format('DD/MM/YYYY')}}
                        customRequest={handleUpload}
                        onChange={this.handleChange.bind(this)}
                        onPreview={onPreview}
                        onRemove={handleDelete}
                        fileList={fileList}
                        showUploadList={false}
                    >
                        <Button disabled={loading || !docType || disabled} style={{width: '100%'}}>
                            <Icon type='upload'/> Select file
                        </Button>
                    </Upload>
                    <Cabinet fileList={fileList} onClick={onClick} onDelete={handleDelete}/>
                </Row>
            </div>
        )
    }
};

export default Document;


// WEBPACK FOOTER //
// ./resources/assets/js/components/provider/property/Document.js